import React from 'react';
import Typography from './Typography';
import { AppThemeColorVariant } from '../../../types/theme';
import theme from '../../theme';

interface IAdminDataFooter {
  className?: string;
  style?: React.CSSProperties;
  colorVariant?: AppThemeColorVariant;
}

export default function AdminDataFooter({
  className,
  colorVariant = 'background',
  style
}: IAdminDataFooter) {
  return (
    <div
      className={'flex w-full h-auto justify-between items-center' + ` ${className}`}
      style={style}>
        <Typography
          variant='button' 
          colorVariant={colorVariant}>
            Wilma Care - Via F-Cavallotti, 30 - 25034 Orzinuovi (BS) - +39 3895320441 - info@wilmacare.it - P.IVA 04170290987
        </Typography>
        <div style={{display: 'flex', gap: theme.sizing.x2}}>
          <span style={{cursor: 'pointer'}} onClick={() => window.open('https://www.iubenda.com/privacy-policy/31147474')?.focus()}>
            <Typography colorVariant='primary' style={{fontWeight: 700}}>
              Privacy Policy
            </Typography>
          </span>
          <span style={{cursor: 'pointer'}} onClick={() => window.open('https://www.iubenda.com/termini-e-condizioni/15049131')?.focus()}>
            <Typography colorVariant='primary' style={{fontWeight: 700}}>
              Termini e Condizioni
            </Typography>
          </span>
        </div>
    </div>
  )
}